export default "__VITE_ASSET__c0a3c143__"